/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Flex, Form, Popconfirm, Tag } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import React from 'react'
import { AntdFormFieldProps, AntdFormItem, AntdFormItemContext, useAntdFormItemContext } from './AntdFormItem'

type AntdFormListProps = {
  fieldProps: AntdFormFieldProps
  children: React.ReactNode
  itemLabel?: string
  disabled?: boolean
  /** When true, deleting an item requires confirmation via a Popconfirm. */
  promptRemove?: boolean
}

export const AntdFormList: React.FC<AntdFormListProps> = ({
  fieldProps,
  itemLabel = 'Item',
  children,
  disabled,
  promptRemove = false,
}) => {
  const { finalName } = useAntdFormItemContext(fieldProps.name)

  return (
    <AntdFormItem {...fieldProps}>
      <Form.List name={finalName as any}>
        {
          (fields, { add, remove }, { errors }) => {
            const renderRemoveButton = (fieldName: number) => {
              const button = (
                <Button
                  icon={<CloseOutlined />}
                  danger
                  type="primary"
                  size="small"
                  htmlType="button"
                  className="text-sm"
                  onClick={promptRemove ? undefined : () => remove(fieldName)}
                  disabled={disabled}
                />
              )

              if (!promptRemove) return button

              return (
                <Popconfirm
                  title={`Remove this item?`}
                  okText="Remove"
                  okButtonProps={{ danger: true }}
                  onConfirm={() => remove(fieldName)}
                  disabled={disabled}
                >
                  {button}
                </Popconfirm>
              )
            }

            return (
              <>
                {fields.map((field) => (
                  <AntdFormItem
                    key={field.key}
                    className="border p-4 rounded-lg relative"
                    noLabel
                  >
                    <Flex justify="space-between" align="center">
                      <Tag color="blue">{itemLabel} {field.name + 1}</Tag>
                      {renderRemoveButton(field.name)}
                    </Flex>
                    <AntdFormItemContext.Provider value={{ fieldPrefix: field.name }}>
                      {children}
                    </AntdFormItemContext.Provider>
                  </AntdFormItem>
                ))}
                <div className="flex flex-row justify-center">
                  <Button type="primary" onClick={() => add()} disabled={disabled}>
                    + Add {itemLabel}
                  </Button>
                </div>
                <Form.ErrorList errors={errors} />
              </>
            )
          }
        }
      </Form.List>
    </AntdFormItem>
  )
}